import { render, staticRenderFns } from "./setSubProcess.vue?vue&type=template&id=34656514&"
import script from "./setSubProcess.vue?vue&type=script&lang=js&"
export * from "./setSubProcess.vue?vue&type=script&lang=js&"
import style0 from "./setSubProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports